import React from 'react';
import { Html } from '@react-three/drei';
import { useModelStore } from '../../../../store/useModelStore';
import { useUIStore } from '../../../../store/useUIStore';
import { scaleToGrid, getScaleFromRange } from '@/utils/gridScale';

/**
 * NodeIDLabels Component
 * 
 * Displays all node IDs in the format "N{id}" when the showNodeIds toggle is enabled.
 * Uses the same formatting as NodeIdTag for consistency.
 */
export const NodeIDLabels: React.FC = () => {
  const nodes = useModelStore((state) => state.nodes);
  const showNodeIds = useUIStore((state) => state.showNodeIds);
  const scaleRange = useUIStore((state) => state.scaleRange);

  // Get scaling factor for coordinates
  const scaleFactor = getScaleFromRange(scaleRange);

  if (!showNodeIds || !nodes || nodes.length === 0) {
    return null;
  }

  return (
    <>
      {nodes.map((node) => (
        <Html
          key={`node-label-${node.id}`}
          position={[
            scaleToGrid(node.x, scaleFactor) + 0.5,
            scaleToGrid(node.y, scaleFactor) + 0.5,
            scaleToGrid(node.z, scaleFactor) + 0.5
          ]}
          center
          zIndexRange={[0, 10]}
        >
          <div
            style={{
              pointerEvents: 'none',
              userSelect: 'none',
              fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial',
              fontSize: '16px',
              fontWeight: 600,
              color: '#1e40af',
              textShadow: '0 0 2px white, 0 0 4px white',
              whiteSpace: 'nowrap',
            }}
          >
            N{node.id}
          </div>
        </Html>
      ))}
    </>
  );
};
